import React from 'react';

const EthicalHackingPython: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        <b>Laporan Kaspersky 2024</b> menunjukkan bahwa serangan siber di Indonesia meningkat <b>300%</b> dalam 3 tahun terakhir. Artikel ini akan membuka pintu dunia <b>ethical hacking</b> menggunakan Python - bahasa pemrograman yang digunakan oleh <b>78% profesional keamanan siber</b> menurut Cybersecurity Association.
      </p>

      <h2 className="text-2xl font-bold mb-4">Apa Itu Ethical Hacking?</h2>
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <p>
          <b>Ethical hacking</b> adalah praktik menguji sistem komputer secara legal untuk menemukan kerentanan sebelum penjahat siber memanfaatkannya. Para ahli ini disebut <b>white hat hackers</b>.
        </p>
      </div>

      <h2 className="text-2xl font-bold mb-4">Tools Python untuk Pemula</h2>
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        {[
          {
            name: "Scapy",
            desc: "Packet manipulation & network scanning",
            code: "send(IP(dst='192.168.1.1')/ICMP())"
          },
          {
            name: "Requests",
            desc: "Web vulnerability testing",
            code: "requests.get('http://test.com/login')"
          },
          {
            name: "Hashlib",
            desc: "Password cracking analysis",
            code: "hashlib.md5(b'password').hexdigest()"
          }
        ].map((tool, idx) => (
          <div key={idx} className="border rounded-lg p-3 bg-white">
            <h3 className="font-bold text-lg mb-2">⚡ {tool.name}</h3>
            <p className="text-sm mb-3">{tool.desc}</p>
            <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
              {tool.code}
            </pre>
          </div>
        ))}
      </div>

      <h2 className="text-2xl font-bold mb-4">3 Proyek Praktis untuk Belajar</h2>
      <ol className="list-decimal pl-6 mb-6 space-y-6">
        <li>
          <p><strong>Network Scanner Sederhana</strong></p>
          <p>Membangun tool untuk mendeteksi perangkat dalam jaringan lokal:</p>
          <pre className="bg-gray-100 p-3 rounded my-2">
            {`import scapy.all as scapy

def scan(ip):
    arp_request = scapy.ARP(pdst=ip)
    broadcast = scapy.Ether(dst="ff:ff:ff:ff:ff:ff")
    scapy.srp(broadcast/arp_request, timeout=1)[0]`}
          </pre>
          <p><b>Konsep yang dipelajari:</b> ARP protocol, packet crafting</p>
        </li>

        <li>
          <p><strong>Password Strength Checker</strong></p>
          <p>Analisis kekuatan password dengan dictionary attack:</p>
          <pre className="bg-gray-100 p-3 rounded my-2">
            {`import hashlib
with open('wordlist.txt') as f:
    for word in f:
        hashed = hashlib.sha256(word.strip().encode()).hexdigest()
        if hashed == target_hash:
            print(f"Password found: {word}")`}
          </pre>
          <p><b>Konsep yang dipelajari:</b> Hash functions, brute-force attack</p>
        </li>

        <li>
          <p><strong>Web Vulnerability Tester</strong></p>
          <p>Deteksi kerentanan SQL Injection dasar:</p>
          <pre className="bg-gray-100 p-3 rounded my-2">
            {`import requests
payloads = ["' OR '1'='1", "'--", "' UNION SELECT null--"]
for payload in payloads:
    r = requests.get(f"http://test.com?id={payload}")
    if "error" in r.text.lower():
        print(f"Vulnerable to: {payload}")`}
          </pre>
          <p><b>Konsep yang dipelajari:</b> Web security, input sanitization</p>
        </li>
      </ol>

      <h2 className="text-2xl font-bold mb-4">Etika dan Legalitas</h2>
      <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
        <p>
          <b>Peringatan:</b> Selalu dapatkan izin tertulis sebelum menguji sistem. Aktivitas hacking tanpa izin adalah <b>tindak pidana</b> yang diatur dalam UU ITE Pasal 30.
        </p>
      </div>

      <h2 className="text-2xl font-bold mb-4">Langkah Selanjutnya</h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li><b>Sertifikasi CEH (Certified Ethical Hacker)</b> - Standar industri untuk profesional</li>
        <li><b>CTF (Capture The Flag)</b> - Kompetisi hacking legal untuk berlatih</li>
        <li><b>Bug Bounty Programs</b> - Dapatkan penghargaan melaporkan kerentanan</li>
      </ul>

      <p className="mb-4">
        <b>Statistik Menarik:</b> Gaji entry-level ethical hacker di Indonesia berkisar <b>Rp15-30 juta/bulan</b> berdasarkan data JobStreet 2024.
      </p>

      <p>
        Mulai perjalanan Anda dengan kursus gratis dari <a href="https://www.cybrary.it" target="_blank" className="underline font-semibold text-defaultBlue">Cybrary</a> atau <a href="https://www.hackthebox.com" target="_blank" className="underline font-semibold text-defaultBlue">Hack The Box</a>. Ingat: <b>Great power comes with great responsibility!</b>
      </p>
    </div>
  );
};

export default EthicalHackingPython;